import qs from 'qs';

export const parseQueryParams = (queryParams: string) => {
  return qs.parse(queryParams, {
    ignoreQueryPrefix: true,
    parseArrays: true,
    plainObjects: true,
  });
};
